//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// network-offline imports
import { DeterioratingClock } from "@components/svgs/DeterioratingClock";
import { styles } from "./ErrorScreen.styles";
// styles
import spacing from "@styles/spacing.styles";
// material-ui
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { WithStyles } from "@material-ui/core/styles/withStyles";

//////////////////
// TYPINGS
//////////////////
export interface IProps extends WithStyles<typeof styles> {
  title?: string;
}

export interface IState {}

//////////////////
// COMPONENT
//////////////////
class ErrorScreenCmpt extends React.Component<IProps, IState> {
  public render() {
    return (
      <div className={this.props.classes.container}>
        <DeterioratingClock style={{ marginTop: 43 }} />
        {this.props.title ? (
          <Typography variant="h6" style={{ marginTop: 18 }}>
            {this.props.title}
          </Typography>
        ) : null}
        <Typography variant="body1" style={{ padding: spacing.lg }}>
          {this.props.children}
        </Typography>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const ErrorScreen = withStyles(styles)(ErrorScreenCmpt);
